import { lineItemHelpers } from '@reveni-io/reveni-ui'

export const getCreateReturnPayload = (items, returnPortalId) => {
  const { getItemForPayload } = lineItemHelpers(items)

  const payload = {
    line_items: items?.map(item => getItemForPayload(item)),
    portal_id: returnPortalId,
  }

  return payload
}
